<template>
  <!-- <Modal
    :lock-scroll="false"
    :mask-closable="false"
    :styles="{top: '40px'}"
    :title="`智能台账【${ledgerForm?.hlSerial}】`"
    @on-cancel="cancelLedger"
    class-name="hlModal"
    footer-hide
    v-model="showLedger"
  >-->
  <div>
    <div class="workbenchContainer">
      <div class="leftWork" style="width: fit-content; max-width: 320px; min-width: 310px;">
        <slot name="extLeft"></slot>
        <div
          class="messageContianer selfPanel flex"
          v-if="currentId && ['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType )>= 0"
        >
          <div class="selfPanelTitle">
            <div>语音转译记录</div>
            <div class="rightBtns">
              <!-- v-if="currentCallRecord && (currentCallRecord.establishedTime && (currentCallRecord.releaseTime == null || currentCallRecord.releaseTime == undefined))" -->
              <Tooltip content="刷新">
                <Icon @click="callConversationInfo" class="pointer" type="md-refresh" />
              </Tooltip>
            </div>
          </div>
          <div class="selfPanelContent">
            <GeminiScrollbar :autoshow="true">
              <div v-if="conversationInfos.length>0">
                <div
                  :class="item.roleType == 'customer'?'left conversationItem':'right conversationItem'"
                  :key="index + '-conversationItem'"
                  v-for="(item, index) in conversationInfos"
                >
                  <template v-if="item.roleType == 'USER' || item.roleType == 'customer'">
                    <h5 class="conversationItemRole">
                      <img
                        :src="require('@/assets/static/images/im/consultant@2x.png')"
                        class="personIcon"
                      />
                      <span>{{item.role}}</span>
                    </h5>
                  </template>
                  <template v-else>
                    <h5 class="conversationItemRole">
                      <span>{{item.role}}</span>
                      <img
                        :src="require('@/assets/static/images/im/lawyer@2x.png')"
                        class="personIcon"
                      />
                    </h5>
                  </template>
                  <div class="conversationItemContent">{{item.words}}</div>
                </div>
              </div>
              <div style="line-height: 4rem;margin-left:5vw;margin-top:2vh;" v-else>暂无语音转译记录</div>
              <a href="#scrollToMe" ref="scrollToMe"></a>
            </GeminiScrollbar>
            <Spin class="selfSpin" v-if="loadingConversation">
              <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
              <div>加载中，请稍候...</div>
            </Spin>
          </div>
        </div>
      </div>
      <div class="rightInfo" v-if="currentId">
        <div class="centerInfo custom-scroll">
          <div class="selfPanel">
            <div
              class="selfPanelTitle"
              v-if="['INBOUND', 'OUTBOUND'].indexOf(currentCallRecord?.callType )>= 0"
            >通话详情</div>
            <div class="selfPanelTitle" v-else>台账详情</div>
            <div class="selfPanelContent">
              <template v-if="ledgerForm.appId !='emergency' && ledgerForm.icSubType == 'HL_MS'">
                <table class="callRecordTable">
                  <tr>
                    <td>数据来源</td>
                    <td>{{getDataSourceName(currentCallRecord.dataSource)}}</td>
                    <td>状态</td>
                    <td>{{currentCallRecord.statusLabel}}</td>
                  </tr>
                  <tr>
                    <td>咨询时间</td>
                    <td>{{currentCallRecord.callTime}}</td>
                    <td>呼入号码</td>
                    <td>{{currentCallRecord.callPhone | desensitizedPhone}}</td>
                  </tr>
                  <tr>
                    <td>接通时间</td>
                    <td>{{currentCallRecord.putThroughTime}}</td>
                    <td>挂断时间</td>
                    <td>{{currentCallRecord.hangUpTime}}</td>
                  </tr>
                  <tr>
                    <td>服务律师</td>
                    <td>{{currentCallRecord.lawyerName}}</td>
                    <td>律师号码</td>
                    <td>{{currentCallRecord.lawyerPhone}}</td>
                  </tr>
                  <tr>
                    <td>等待时长（秒）</td>
                    <td>{{currentCallRecord.waitTime}}</td>
                    <td>通话时长（秒）</td>
                    <td>{{currentCallRecord.callDuration}}</td>
                  </tr>
                  <tr>
                    <td>是否已评价</td>
                    <td>{{currentCallRecord.satisfactionEvaluated?'是':'否'}}</td>
                    <td>满意度结果</td>
                    <td>{{currentCallRecord.satisfactionResultLabel}}</td>
                  </tr>
                </table>
              </template>
              <template
                v-else-if="ledgerForm.appId !='emergency' && ledgerForm.icSubType =='HL_FP'"
              >
                <table
                  class="callRecordTable"
                  v-if=" ['INBOUND', 'OUTBOUND'].indexOf(currentCallRecord?.callType )>= 0"
                >
                  <tr>
                    <td>呼叫类型</td>
                    <td>{{callTypes[currentCallRecord?.callType] || '--'}}</td>
                    <td>{{callTypes[currentCallRecord?.callType] || '开始'}}时间</td>
                    <td>{{currentCallRecord?.startTime}}</td>
                  </tr>
                  <tr>
                    <td>接听时间</td>
                    <td>{{currentCallRecord?.establishedTime || '--'}}</td>
                    <td>结束时间</td>
                    <td>{{currentCallRecord?.releaseTime || '--'}}</td>
                  </tr>
                  <tr>
                    <td>通话时长</td>
                    <td>{{currentCallRecord?.callDuration || '--'}}</td>
                    <td>挂断方</td>
                    <td>{{currentCallRecord?.releaseInitiator || '--'}}</td>
                  </tr>
                  <tr>
                    <td>主叫号码</td>
                    <td>{{currentCallRecord?.caller}}</td>
                    <td>主叫归属地</td>
                    <td>{{currentCallRecord?.callerLocation}}</td>
                  </tr>
                  <tr>
                    <td>被叫号码</td>
                    <td>{{currentCallRecord?.callee}}</td>
                    <td>被叫归属地</td>
                    <td>{{currentCallRecord?.calleeLocation}}</td>
                  </tr>
                  <tr v-if="currentCallRecord?.releaseTime">
                    <td>发送满意度调查</td>
                    <td>{{currentCallRecord?.satisfactionSurveyOffered?'是':'否'}}</td>
                    <td>满意度结果</td>
                    <td>{{satisfactionResultMap[currentCallRecord?.satisfaction]?.label}}</td>
                    <!-- <td>{{currentCallRecord?.satisfaction}}</td> -->
                  </tr>
                  <!-- <tr v-if="currentCallRecord?.releaseTime">
                  <td>挂断方</td>
                  <td>{{currentCallRecord?.releaseInitiator}}</td>
                  <td>挂断类型</td>
                  <td>{{$common.hangUpTypes[currentCallRecord?.hangUpType]}}</td>
                  </tr>-->
                </table>
              </template>
              <table class="callRecordTable" v-else>
                <tr>
                  <td>台账类型</td>
                  <td>
                    <dicLabel
                      :value="ledgerForm?.callQueue"
                      category="CALL_QUEUE"
                      class="ledgerInfo"
                      defaultValue="--"
                    ></dicLabel>
                  </td>
                  <td>创建时间</td>
                  <td>{{ledgerForm?.callTime}}</td>
                </tr>
                <tr v-if="ledgerForm?.callType=='INBOUND'">
                  <td>主叫号码</td>
                  <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
                  <td>主叫归属地</td>
                  <td>{{ledgerForm?.phoneLocation || '--'}}</td>
                </tr>
                <tr v-else-if="ledgerForm?.callType=='OUTBOUND'">
                  <td>呼出号码</td>
                  <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
                  <td>呼出归属地</td>
                  <td>{{ledgerForm?.phoneLocation || '--'}}</td>
                </tr>
                <tr>
                  <td>开始时间</td>
                  <td>{{ledgerForm?.callTime || '--'}}</td>
                  <td>结束时间</td>
                  <td>{{ledgerForm?.finishTime || '--'}}</td>
                </tr>
              </table>
              <template v-if="fileUrl">
                <Divider orientation="left">录音文件</Divider>
                <audio
                  controls
                  controlslist="nodownload"
                  ref="audio"
                  style=" min-width: 100%;"
                  width="100%"
                >
                  <source :src="fileUrl" />
                </audio>
              </template>
            </div>
          </div>
          <div
            class="selfPanel mt1"
            v-if="ledgerForm && ['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType)  >= 0"
          >
            <div class="selfPanelTitle">
              <div>咨询内容</div>
              <div class="rightBtns" v-if="ledgerForm?.id">
                <Button
                  @click="waitLedger"
                  size="small"
                  type="primary"
                  v-if="ledgerForm?.consultationStatus != 'finish'"
                >暂存</Button>
                <Button @click="saveLedger" size="small" type="error">保存</Button>
              </div>
            </div>
            <div class="selfPanelContent">
              <Form
                :label-width="100"
                :model="ledgerForm"
                :rules="ledgerFormValidate"
                ref="ledgerForm"
              >
                <Row>
                  <Col :xs="24">
                    <FormItem label="主业务类型" prop="mainBusinessTypeId">
                      <bussinessTypeTreeSelect
                        :multiple="false"
                        :value="ledgerForm.mainBusinessTypeId"
                        @change="changeMainBussinessTypeSet"
                        placeholder="请选择主业务类型"
                      />
                    </FormItem>
                  </Col>
                  <Col :xs="24">
                    <FormItem label="次业务类型">
                      <bussinessTypeTreeSelect
                        :multiple="true"
                        :values="ledgerForm.minorBusinessTypeIds"
                        @change="changeMinorBussinessTypeSet"
                        placeholder="请选择次业务类型"
                      />
                    </FormItem>
                  </Col>

                  <Col :sm="24" :xs="24">
                    <FormItem label="咨询主题" prop="subject">
                      <Input
                        clearable
                        placeholder="请输入咨询主题"
                        type="text"
                        v-model.trim="ledgerForm.subject"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col :sm="24" :xs="24">
                    <FormItem label="客户自述" prop="clientDescription">
                      <Input
                        :autosize="{ minRows: 3, maxRows: 10 }"
                        maxlength="1000"
                        show-word-limit
                        type="textarea"
                        v-model.trim="ledgerForm.clientDescription"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col :sm="24" :xs="24">
                    <FormItem label="处理意见" prop="lawyerSuggestion">
                      <Input
                        :autosize="{ minRows: 3, maxRows: 10 }"
                        maxlength="1000"
                        show-word-limit
                        type="textarea"
                        v-model.trim="ledgerForm.lawyerSuggestion"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col :sm="12" :xs="24">
                    <FormItem label="所属企业类型" prop="entType">
                      <labelValue
                        :category="'ENT_TYPE'"
                        :data="ledgerForm.entType"
                        @change="(val) => {ledgerForm.entType = val}"
                      ></labelValue>
                    </FormItem>
                  </Col>
                  <Col :sm="12" :xs="24">
                    <FormItem label="服务单号" prop="serviceNo">
                      <Input
                        clearable
                        placeholder="请输入服务单号"
                        type="text"
                        v-model.trim="ledgerForm.serviceNo"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col :sm="12" :xs="24">
                    <FormItem label="事件标签">
                      <Select
                        clearable
                        filterable
                        placeholder="请选择事件标签"
                        v-model="ledgerForm.eventTag"
                      >
                        <Option
                          :key="item.val"
                          :value="item.val"
                          v-for="item in eventTags"
                        >{{ item.label }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :sm="12" :xs="24">
                    <FormItem label="事发时间">
                      <Date-picker
                        @on-change="(val)=>{ledgerForm.sourceTime = val}"
                        format="yyyy-MM-dd HH:mm:ss"
                        placeholder="事发时间"
                        style="width: 100%"
                        type="datetime"
                        v-model="ledgerForm.sourceTime"
                      ></Date-picker>
                    </FormItem>
                  </Col>
                  <Col :sm="24" :xs="24">
                    <FormItem label="事发地点">
                      <Input
                        clearable
                        placeholder="请输入事发地点"
                        type="text"
                        v-model.trim="ledgerForm.sourceAddress"
                      ></Input>
                    </FormItem>
                  </Col>
                  <Col :sm="24" :xs="24">
                    <FormItem label="自定义标签" prop="tags">
                      <Select
                        @on-create="createTag"
                        allow-create
                        filterable
                        multiple
                        v-model="ledgerForm.tags"
                      >
                        <Option :key="item" :value="item" v-for="item in tagList">{{ item }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
        <div
          class="rightToolContianer"
          v-if="['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType)  >= 0"
        >
          <div class="selfPanel flex" style="height: 100%;">
            <div class="selfPanelTitle">
              <div class="toolBars">
                <div
                  :class="toolType == 'personInfo'?'active toolBar':'toolBar'"
                  @click="changeTool('personInfo')"
                  v-if="currentPhone"
                >咨询人画像</div>
                <div
                  :class="toolType == 'ai'?'active toolBar':'toolBar'"
                  @click="changeTool('ai')"
                  class="toolBar"
                >智能推送</div>
              </div>
            </div>
            <div class="selfPanelContent toolBody">
              <template v-if="toolType == 'personInfo' ">
                <consultantPortrait
                  :consultantInfo="consultantInfo"
                  :disabledName="disabledName"
                  v-if="consultantInfo"
                />
                <Spin class="selfSpin" v-if="loadingPortrait">
                  <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
                  <div>加载中，请稍候...</div>
                </Spin>
              </template>
              <knowledgeSearchTool
                :keyWords="keywords"
                ref="knowledgeSearchTool"
                v-else-if="toolType == 'ai'"
              />
            </div>
          </div>
          <!-- <div class="selfPanel mt1">
            <div class="selfPanelTitle">风险管理</div>
            <div class="selfPanelContent"></div>
          </div>-->
        </div>
      </div>
    </div>
    <Spin fix v-if="spinShow">
      <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
      <div>操作中，请稍候...</div>
    </Spin>
  </div>
  <!-- </Modal> -->
</template>
<script>
import labelValue from '@/components/labelValue.vue'
export default {
  components: { labelValue },
  name: 'hldetail',
  props: {
    currentId: {
      required: false,
      type: Number,
      default: function () {
        return null
      }
    },
    // show: {
    //   required: false,
    //   default: false
    // },
    edit: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      callTypes: {},
      satisfactionResultOptions: [],
      satisfactionResultMap: {},
      toolType: 'personInfo',
      statusCode: null,
      eventTags: [],
      spinShow: false,
      showPanel: false,
      activeConfig: {},
      ledgerForm: {},
      consultantInfo: null,
      currentCallRecord: null,
      currentUser: null,
      conversationInfos: [],
      keywords: [],
      loadingConversation: false,
      disabledName: false,
      tagList: [],
      defaultTagList: [],
      callTypeOptions: [],
      ledgerFormValidate: {
        mainBusinessTypeId: [{ required: true, type: 'number', message: '请选择主业务类型', trigger: "change" }],
        clientDescription: [{ required: true, message: '请输入客户自述内容', trigger: "blur" }],
        lawyerSuggestion: [{ required: true, message: '请输入处理意见', trigger: "blur" }],
        leAges: [{ required: true, message: '请选择年龄段', trigger: "change" }],
        leGender: [{ required: true, message: '请选择性别', trigger: "change" }],
        leProfession: [{ required: true, message: '请选择职业', trigger: "change" }],
        leConsultationType: [{ required: true, message: '请选择客户类别', trigger: "change" }],
        leEducational: [{ required: true, message: '请选择学历', trigger: "change" }],
        name: [{ required: true, message: '请填写咨询人姓名', trigger: 'blur' }],
        subject: [{ required: true, message: '请填写咨询主题', trigger: 'blur' }],
      },
      timerMessage: null,
      loadingPortrait: false,
      currentPhone: null,
      showLedger: false,
      dataSources: [],
      fileUrl: null
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
  },
  watch: {
    edit: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.isEdit = val
      }
    },
    currentId: {
      immediate: true,
      deep: true,
      handler: function (val) {
        console.log(val, 'cId')
        if (val) this.ledgerInfo()
      }
    }
  },
  methods: {
    getBasePath: async function (fileId) {
      console.log('this.fileId', fileId)
      if (fileId) {
        let params = new URLSearchParams()
        params.append("id", fileId)
        let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
        this.fileUrl = data.result
      }

      // return data.result
    },
    getDataSourceOptions: async function () {
      this.dataSources = await this.$baseData.handleData(false, this.$apis.projectManagementApi.getDataSourceOptions, null)
    },
    getDataSourceName: function (dataSource) {
      let da = this.dataSources.filter(item => item.code == dataSource)
      if (da.length > 0) {
        return da[0].remark
      } else {
        return ''
      }
    },
    cancelLedger: function () {
      this.ledgerForm = {}
      this.currentCallRecord = null
      this.consultantInfo = null
      this.tagList = this.defaultTagList
      this.$emit('cancelLedger')
    },
    hotlineList: function () {
      this.$emit('hotlineList')
    },
    ledgerInfo: function () {
      let that = this
      if (that.currentId == null || that.currentId == undefined) return
      let params = new this.$URLSearchParams()
      that.showLedger = true
      that.ledgerForm = {}
      that.currentCallRecord = {}
      params.append("id", that.currentId)
      that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerInfo, params).then(res => {
        if (res.success) {
          that.ledgerForm = res.result?.ledger || {}
          that.getBasePath(that.ledgerForm.fileId)
          that.currentCallRecord = res.result?.hlRecord || {}
          // that.loadHLRecord()
          that.currentPhone = that.ledgerForm.phoneNumber
          if (that.currentPhone) that.getPortrait(that.currentPhone)
        } else {
          that.$Message.error({
            content: res.message || '获取台账记录失败！',
            duration: 3


          })
        }
      }).catch(function (err) {
        console.log('ledgerInfo error', err)
        that.$Message.error({
          content: '获取台账记录失败！',
          duration: 3
        })
      })
    },
    changeTool: function (value) {
      if (this.toolType != value) {
        this.toolType = value
        switch (this.toolType) {
          case 'personInfo':
            if (this.currentPhone) {
              this.getPortrait(this.currentPhone)
            }
        }
      }
    },
    createTag: function (value) {
      let that = this
      this.$axios.post(this.$apis.ICHLApi.tag.saveOrUpdate, { name: value }).then(res => {
        if (res.success) {
          that.$Message.success("添加标签成功！")
          that.tagList.push(value)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("添加标签成功！")
      })
    },
    scrollToDom (el) {
      this.$nextTick(() => { // 等待 DOM 渲染完成
        if (el) { // 如果元素存在，则滚动到目标位置
          el.scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      })
    },

    getPortrait: function (telePhone) {
      let that = this
      that.consultantInfo = null
      that.loadingPortrait = true
      let params = new this.$URLSearchParams()
      params.append("telPhone", telePhone)
      that.$axios.post(that.$apis.consultantManager.portrait.getPortrait, params).then(res => {
        if (res.success) {
          that.consultantInfo = res.result || {}
        } else {
          that.$Message.error({
            content: res.message || '获取咨询人画像！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('getPortrait error', err)
        that.$Message.error({
          content: '获取咨询人画像',
          duration: 3
        })
      }).finally(() => {
        setTimeout(() => {
          that.loadingPortrait = false
        }, 500)
      })
    },
    /**
     * 获取话务文本
     */
    callConversationInfo: function () {
      let that = this
      if (that.currentId) {
        this.loadingConversation = true
        let params = new this.$URLSearchParams()
        params.append("ledgerId", that.currentId)
        that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerConInfo, params).then(res => {
          if (res.success) {
            that.conversationInfos = res.result?.callConversationInfos || []
            that.keywords = res.result?.keywords || []
          } else {
            that.$Message.error({
              content: res.message || '获取通话文本内容失败！',
              duration: 3
            })
          }
        }).catch(function (err) {
          console.log('callConversationInfo error', err)
          that.$Message.error({
            content: '获取通话文本内容失败！',
            duration: 3
          })
        }).finally(() => {
          that.scrollToDom(that.$refs.scrollToMe)
          that.loadingConversation = false
        })
      }
    },
    initTagList: function () {
      let that = this
      this.tagList = []
      this.defaultTagList = []
      this.$axios.post(that.$apis.ICHLApi.tag.tagOptions).then(res => {
        if (res.success) {
          that.tagList = res.result || []
          that.defaultTagList = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取事件标签失败！")
      })
    },
    getCallTypeOptions: function () {
      let that = this
      this.callTypes = {}
      this.$axios.post(that.$apis.ICHLApi.hotlineApi.getCallTypeOptions).then(res => {
        if (res.success) {
          that.callTypeOptions = res.result || []
          that.callTypeOptions.forEach(item => {
            that.callTypes[item.value] = item.label
          })
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("获取呼叫类型参数失败！")
      })
    },
    initBaseData: function () {
      this.eventTags = []
      this.getDic("EVENT_TAG").then(val => {
        this.eventTags = val
      })
      this.getCallTypeOptions()
      this.initTagList()
    },
    changeMainBussinessTypeSet: function (data) {
      console.log('changeMainBussinessTypeSet', data)
      if (data && data.id) {
        this.$set(this.ledgerForm, 'mainBusinessTypeId', data.id)
      } else {
        this.$delete(this.ledgerForm, 'mainBusinessTypeId')
      }
    },
    changeMinorBussinessTypeSet: function (data) {
      let ids = []
      data.forEach((item) => { ids.push(item['id']) })
      if (this.ledgerForm) this.$set(this.ledgerForm, 'minorBusinessTypeIds', ids)
    },
    //暂存
    waitLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'wait'
      if (this.ledgerForm.sourceTime) {
        this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
      }
      this.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
        if (res.success) {
          that.$Message.success("暂存成功！")
          that.ledgerInfo()
          // that.hotlineList()
          // that.cancelLedger()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('waitLedger error', waitLedger)
        that.$Message.error("操作失败！")
      }).finally(() => {
        that.spinShow = false
      })
    },

    //保存台账
    saveLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'finish'
      this.$refs["ledgerForm"].validate(valid => {
        if (valid) {
          if (this.ledgerForm.sourceTime) {
            this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
          }
          that.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
            if (res.success) {
              that.$Message.success("保存成功！")
              that.ledgerInfo()
              // that.hotlineList()
              // that.cancelLedger()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            console.log('saveLedger error', waitLedger)
            that.$Message.error("操作失败！")
          }).finally(() => {
            that.spinShow = false
          })
        } else {
          that.spinShow = false
          return false
        }
      })

    },
    loadSatisfactionResults: async function () {
      this.satisfactionResultOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
      this.satisfactionResultOptions.forEach(item => {
        this.satisfactionResultMap[item.code] = item
      })
    },
    show: function () {
      console.log('show', this.currentId)
      this.ledgerInfo()
    },
    hide: function () {
      console.log('hide', this.currentId)
    }
  },
  beforeMount () {
    this.getDataSourceOptions()
    this.loadSatisfactionResults()
    this.initBaseData()
  },
  destroyed () {
    this.currentCallRecord = null
    window.workbench = null
  }
}
</script>

